/* eslint-disable */
import React, { useContext, FunctionComponent, useState, useMemo, useEffect } from 'react';
import { positionType } from './SidebarContext';

// Custom components
import SidebarContext from '@/context/SidebarContext/SidebarContext';
import MapContext from '@/context/MapContext/MapContext';

const OL_RIGHT_CONTROL_CLASSNAMES = ['ol-rotate', 'ol-base-layer-switcher', 'ol-coord-zoom-status', 'ol-status-control'];

const SidebarProvider: FunctionComponent<any> = (props) => {
  const mapContext = useContext(MapContext);
  const { onTabChange, positionProp, initialOpenId, children, initialOpenHeading, onSidebarCollapse, sidebarId, isHidden } = props;

  // Configure here default settings for Sidebar: collapsed, default pane
  const [position, setPosition] = useState<positionType>(positionProp !== undefined ? positionProp : 'left');
  const [activePane, setPane] = useState<string | null>(initialOpenId !== undefined ? initialOpenId : null);
  const [collapsed, setCollapse] = useState<boolean>(initialOpenId === undefined);

  const [hidden, setHidden] = useState<boolean>(isHidden);

  useEffect(() => {
    if (isHidden === undefined) return;

    setHidden(isHidden);
    if (isHidden) {
      setCollapsed(true);
    } else {
      setCollapse(false);
      mapContext?.setSidebarCollapsed(false);
    }
  }, [isHidden]);

  // Hacky as all my code is but there was no better way to do this
  const updateControlClasses = (hidden: boolean, collapsed: boolean) => {
    const targetClass = hidden ? 'hidden' : collapsed ? 'collapsed' : 'open';

    OL_RIGHT_CONTROL_CLASSNAMES.forEach((className) => {
      const element = document.querySelector(`.${className}`);
      if (element) {
        // Remove all state classes
        element.classList.remove('sidebar-map-control-open');
        element.classList.remove('sidebar-map-control-collapsed');
        element.classList.remove('sidebar-map-control-hidden');

        // Add the appropriate class
        element.classList.add(`sidebar-map-control-${targetClass}`);
      }
    });
  };

  // Update control classes when hidden or collapsed state changes
  useEffect(() => {
    if (position === 'right') {
      updateControlClasses(hidden, collapsed);
    }
  }, [hidden, collapsed]);

  const [sidebarHeading, handleSetSidebarHeading] = useState<string>(initialOpenHeading !== undefined ? initialOpenHeading : '');

  const setActivePane = (id: string): void => {
    if (onTabChange) {
      onTabChange(id);
    }
    setPane((prevState) => (prevState !== id ? id : null));
    const isCollapsed = activePane === id;
    setCollapse(isCollapsed);
    mapContext?.setSidebarCollapsed(isCollapsed);
  };

  const setCollapsed = (isCollapsed: boolean): void => {
    if (isCollapsed) {
      if (onTabChange) {
        onTabChange();
      }
      setTimeout(() => setPane(null), 380);
      setCollapse(true);
      mapContext?.setSidebarCollapsed(true);
    } else {
      setCollapse(true);
      mapContext?.setSidebarCollapsed(true);
    }
  };

  const setSidebarHeading = (heading: string) => {
    handleSetSidebarHeading(heading);
  };

  useEffect(() => {
    if (onSidebarCollapse) {
      onSidebarCollapse(collapsed);
    }
  }, [collapsed]);

  const providerValue = useMemo(
    () => ({
      activePane,
      collapsed,
      setActivePane,
      setCollapsed,
      position,
      setSidebarHeading,
      sidebarHeading,
      hidden,
      setHidden,
    }),
    [position, activePane, sidebarHeading, collapsed, hidden]
  );

  return <SidebarContext.Provider value={providerValue}>{children}</SidebarContext.Provider>;
};

export default SidebarProvider;
